import { render } from "./PublicLicenseDirectory.vue?vue&type=template&id=bf29c650"
import script from "./PublicLicenseDirectory.vue?vue&type=script&lang=js"
export * from "./PublicLicenseDirectory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__